module.exports = __webpack_public_path__ + "img/20180815_151629_183.588bd072.jpg";